import React, { useState } from "react";
import Textfield from "../textfield";
import Timepicker from "../timepicker";
import Select from "../select";
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
// import 'react-datepicker/dist/react-datepicker.css';

function TextFieldDropdown({
	className,
	onChange,
	onValueChange,
	inputNumberName = "",
	inputNumber,
	dropdownValueName = "",
	dropdownId,
	typeName = "",
	placeholder = "",
	dropdownOptions = [
		{ label: "Option 1", value: 1 },
		{ label: "Option 2", value: 2 },
	],
	value = "",
	isReadOnlys = false,
	isDisabled = false,
	minFractionDigits = 0,
	disabled,
}) {
	return (
		<div className={` ${className}`}>
			<div className="p-inputgroup grid grid-cols-11">
				<InputNumber
					placeholder={placeholder}
					disabled={disabled}
					
					minFractionDigits={minFractionDigits}
					className="col-span-5"
					pt={{
						root: {
							className: "border border-gray-200  w-full h-10",
						},
					}}
					name={inputNumberName}
					value={inputNumber}
					onValueChange={onValueChange}
				/>
				<span className="p-inputgroup-addon p-0 h-10 col-span-6">
					{/* <span className="text-black">{"coins"}</span> */}

					<Dropdown
						options={dropdownOptions}
						disabled={isDisabled}
						readOnly={isReadOnlys}
						name={dropdownValueName}
						value={dropdownId}
						onChange={onChange}
						className="w-full h-full items-center text-center border-none rounded-r-lg rounded-l-none bg-primary-primaryYellow"
					/>
				</span>
			</div>
		</div>
	);
}

export default TextFieldDropdown;
